export default "__VITE_ASSET__EyRrBltI__"